/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { filterPeopleByRole, IMediaModel, PersonInAssetType } from "@nf/common";
import { useTranslation } from "next-i18next";
import { MediaPeopleLinks } from "../MediaPeopleLinks";
import MediaSpecificationList from "../MediaSpecificationList";

import styles from "./MediaDetailsDescriptionList.module.scss";

interface MediaDetailsDescriptionListSectionProps {
  title: string;
  children: React.ReactNode;
}

const MediaDetailsDescriptionListSection = ({
  title,
  children,
}: MediaDetailsDescriptionListSectionProps) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.content}>{children} </p>
    </div>
  );
};

interface MediaDetailsDescriptionListProps {
  media: IMediaModel;
}

export const MediaDetailsDescriptionList = ({
  media,
}: MediaDetailsDescriptionListProps) => {
  const { t } = useTranslation("translations");

  const actors =
    filterPeopleByRole(media.People, PersonInAssetType.Actor) ?? [];
  const directors =
    filterPeopleByRole(media.People, PersonInAssetType.Director) ?? [];

  return (
    <>
      {actors?.length > 0 && (
        <MediaDetailsDescriptionListSection title={t("web_asset_page_cast")}>
          <MediaPeopleLinks people={actors} />
        </MediaDetailsDescriptionListSection>
      )}

      {directors.length > 0 && (
        <MediaDetailsDescriptionListSection
          title={t("web_asset_page_director")}
        >
          <MediaPeopleLinks people={directors} />
        </MediaDetailsDescriptionListSection>
      )}

      {/* TODO translation */}
      <MediaDetailsDescriptionListSection title="Specs">
        <MediaSpecificationList media={media} />
      </MediaDetailsDescriptionListSection>
    </>
  );
};

export default MediaDetailsDescriptionList;
